import React from "react"
import { Helmet } from "react-helmet"

import metaImage from "../../assets/images/meta/meta-image.jpg"

const index = ({ title, description }) => {
  return (
    <Helmet
      htmlAttributes={{
        lang: "en",
      }}
    >
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="og:description" content={description} />
      <meta name="image" content={metaImage} />
      <meta name="og:image" content={metaImage} />
      <meta
        name="facebook-domain-verification"
        content="031irsg3pu5j7fsayu63yc232dvdos"
      />

      <script src="https://app.termageddon.com/js/termageddon.js"></script>
    </Helmet>
  )
}

export default index
